module.exports = __webpack_public_path__ + "img/3D-2BHK-t2.dfe0722a.png";